
<template>
  <div class="app">
    <GeneBody :key="$route.fullPath"/>
  </div>
</template>


<script>
import GeneBody from './components/GeneBody'

// import NoNav1Body from './components/NoNav1Body.vue'
export default {
  name: 'App',
  components: { GeneBody},
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
}
</style>
